import { ISO8601TupleType, ISO8601Type } from 'types/common.types';
import { transformObjectValuesArrayToSingle } from 'utils';
import { DateTime } from 'luxon';

export const getHourAndMinute = (hourAndMinString: string): number[] => {
  return hourAndMinString.split(':').map((str: string) => parseInt(str));
};

export const getShiftStartTimeAndEndTime = (args: {
  startDate?: ISO8601Type | ISO8601Type[];
  startAt: string | string[];
  endAt: string | string[];
  timeZone: string | undefined;
}): ISO8601TupleType => {
  const { startDate, startAt, endAt, timeZone } = transformObjectValuesArrayToSingle(args);
  const _startDate = startDate ? DateTime.fromISO(startDate) : DateTime.now();
  const [startHour, startMinute] = getHourAndMinute(startAt);
  const [endHour, endMinute] = getHourAndMinute(endAt);
  const start_time = _startDate.set({ hour: startHour, minute: startMinute });

  let end_time = _startDate.set({ hour: endHour, minute: endMinute });

  if (start_time >= end_time) {
    end_time = end_time.plus({ days: 1 });
  }

  return [String(start_time.setZone(timeZone).toISO()), String(end_time.setZone(timeZone).toISO())];
};
